export default {
      id: "ic_help_white-usage",
      viewBox: "0 0 14 15",
      url: "/" + "images/icons.3.109.2.svg#ic_help_white-usage",
      toString: function () {
        return this.url;
      }
    }